import React from "react";
import { useAuth } from "../../hooks/useAuth";
import { CommonRouteProps } from "../../types";
import Loading from "../../../../components/Loading";
import AuthRoute from "./AuthRoute";
import GuestRoute from "./GuestRoute";

const CommonRoute = (props: CommonRouteProps) => {
  const {
    data: { authorizing, isAuthenticated },
  } = useAuth();

  return authorizing ? (
    <Loading />
  ) : isAuthenticated ? (
    <AuthRoute {...props} />
  ) : (
    <GuestRoute {...props} />
  );
};

export default React.memo(CommonRoute);
